import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { ListSearch } from '@fry/lib/list';

@Injectable()
export class VenuesSearch implements ListSearch {

  constructor(
  ) {}

  public filters() {
    return of([
      {
        id: 'text',
        label: '',
        filter: (item, value) => {
          return of((item.doc.name || '').toLowerCase().indexOf(value.toLowerCase()) !== -1);
        },
        featured: true,
        widget: {
          type: 'string',
          placeholder: $localize `Full text search`,
        }
      }
    ]);
  }

  public sorts() {
    return of([
      {
        id: 'name',
        name: $localize `Name`,
      }
    ]);
  }

}
